import React, { Component } from 'react'
import Overlay from '../components/overlay'
import axios from '../utilities/axios'
import AccountAccessPanel from '../components/signin-panel'

const Context = React.createContext()

class Global extends Component {
	constructor(props) {
		super(props)
		var user = null
		var mode = 'buyer'
		if(localStorage.hasOwnProperty('user')) {
			var value = localStorage.getItem('user')
			user = JSON.parse(value)
		}
		if(localStorage.hasOwnProperty('mode')) {
			mode = localStorage.getItem('mode')
		} else {
			localStorage.setItem('mode', mode)
		}
		this.state = {
			user: user, 
			overlayContent: null,
			loginOverlay: null,
			overlayExitCB: null, 
			stripe: null, 
			mode: mode,
			threads: [],
			showMsgPanel: false,
			showMenu: false,
			activeThread: null,
			activeThreadMetadata: null,
			enableMessaging: true,
			sandboxState: null
		}
	}

	_isMounted = false
	_intervalID = null

	loadMessages = () => {}

	syncUser = (initial=false, callback=() => {}) => {
		axios.get('user/self').then(response => {
			if(this._isMounted) {
				if(response.data?.user) {
					this.setState({user: response.data.user}, callback)
					localStorage.setItem('user', JSON.stringify(response.data.user))
				} else {
					this.setState({user: null}, callback)
					localStorage.removeItem('user')
					localStorage.removeItem('storage_enabled')
					localStorage.removeItem('prompts')
					localStorage.removeItem('initial-context')
				}
			}
		}).catch(err => {
			if(err && err.response && err.response.status === 401) {
				if(this._isMounted) {
					this.setState({user: null}, callback)
					localStorage.removeItem('user')
					localStorage.removeItem('prompts')
					localStorage.removeItem('initial-context')
				}
			} else if(err && err.response && initial) {
				if(this._isMounted) {
					this.setState({user: null}, callback)
					localStorage.removeItem('user')
					localStorage.removeItem('prompts')
					localStorage.removeItem('initial-context')
				}
			} else console.log(err)

			this.setState({user: null}, callback)
		})
	}

	logOutUser = () => {
		axios.post('user/logout', {logoutAll: false}).then(response => {
			if(this._isMounted) {
				if(response.data?.currentStatus === 'success') {
					localStorage.removeItem('user')
					localStorage.removeItem('prompts')
					localStorage.removeItem('initial-context')
					localStorage.removeItem('context_enabled')
					localStorage.removeItem('storage_enabled')
					localStorage.removeItem('service-enabled')
					localStorage.removeItem('sandbox')
					this.setState({user: null}, () => {
						window.location.replace('/')
					})
				} else {
					window.location.replace('/dashboard')
				}
			}
		})
	}

	threadLookup = (sellerID) => {
		if(sellerID) {
			let potentialThread = this.state.threads.filter((value, idx) => {
				let {threadID} = value
				if((
					threadID.buyerID === this.state.user?._id && threadID.sellerID === sellerID)
					||
					(threadID.sellerID === this.state.user?._id && threadID.buyerID === sellerID)
				) {
					return threadID._id
				} else return null
			})
			if(potentialThread.length > 0) {
				return potentialThread[0].threadID._id
			} else return null
		} else {
			return null
		}
	}

	patchUser = (updateDicts = {}) => {
		let newUser = {...this.state.user}
		Object.keys(updateDicts).forEach(element => {
			newUser[element] = updateDicts[element]
		})
		this.setState({
			user: newUser
		})
	}

	markThreadReadOffline = (id) => {
		if(id) {
			let potentialThreadForUpdate = null
			let tempThreads = this.state.threads.filter((value, idx) => {
				let {threadID} = value
				if(threadID._id === id) {
					potentialThreadForUpdate = {...value}
					return null
				} else {
					return value
				}
			})
			if(potentialThreadForUpdate) {
				let {threadID} = potentialThreadForUpdate
				threadID['buyerLastRead'] = String(new Date().toISOString())
				threadID['sellerLastRead'] = String(new Date().toISOString())
				potentialThreadForUpdate['threadID'] = threadID
				tempThreads = [...tempThreads, potentialThreadForUpdate]
				this.setState({threads: tempThreads})
			}
		}
	}

	loadStripe = () => {
		axios.get('user/self-payment').then(response => {
			if(this._isMounted) {
				if(response.data?.url) {
					this.setState({ stripe: {url: response.data.url, ready: true} })
				} else if(response.data?.msg === 'not_ready') {
					this.setState({ stripe: null })
				} else {
					this.setState({ stripe: {url: null, ready: false} })
				}
			}
		}).catch(err => {
			if(err && err.response && err.response.status === 401) {
				if(this._isMounted) {
					this.setState({ user: null, stripe: null })
				}
			} else console.log(err)
		})
	}

	isPurchased = (itemID) => {
		const purchases = this.state.user?.purchases || {}
		return itemID in purchases
	}

	setAccountMode = (mode) => {
		if(mode === 'buyer' || mode === 'seller') {
			this.setState({mode: mode})
			localStorage.setItem('mode', mode)
		}
	}

	componentDidMount() {
		this._isMounted = true
		this.syncUser(true)
	}

	toggleAccountAccess = (mode = null, disableClose = false) => {
		const { user } = this.state || {}
		if (user?._id) {
			this.setState({ loginOverlay: null })
			return
		}
		this.setState({
			loginOverlay: ['login', 'create-new'].includes(mode) ? `${mode}${disableClose ? '-forced' : ''}` : null
		})
	}


	render() {
		return(
			<Context.Provider value = {{
				globalState: this.state,
				setGlobalState: this.setState.bind(this),
				syncUser: this.syncUser,
				patchUser: this.patchUser,
				loadStripe: this.loadStripe,
				isPurchased: this.isPurchased,
				setAccountMode: this.setAccountMode,
				threadLookup: this.threadLookup,
				loadMessages: this.loadMessages,
				markThreadReadOffline: this.markThreadReadOffline,
				logOutUser: this.logOutUser,
				toggleAccountAccess: this.toggleAccountAccess
			}}>
				{ this.state.overlayContent !== null ? 
					<Overlay 
						content={ this.state.overlayContent }
						close={ () => {
							this.setState({ overlayContent: null })
							if(this.state?.overlayExitCB) {
								this.state.overlayExitCB()
								this.setState({ overlayExitCB: null })
							}
						}}
					/>
					:
					null
				}
				{
					!!(this.state.loginOverlay) ?
						this.state.loginOverlay.endsWith('-forced') ?
							<AccountAccessPanel panelMode={this.state.loginOverlay.replace(/-forced$/, '')} isCloseDisabled={true}/>
							:
							<AccountAccessPanel panelMode={this.state.loginOverlay}/>
						:
						null
				}
				{this.props.children}
			</Context.Provider>
		)
	}

	componentWillUnmount() {
		this._isMounted = false
		if(this._intervalID) {
			clearInterval(this._intervalID)
		}
	}
}

export {Global, Context}